export const FALLBACK_ERROR_MESSAGE = 'An unexpected error has occurred';
export const TOKENEX_DOWN_MESSAGE =
  'Our payment provider is currently having issues with accepting some credit cards, please try back later.';
